// policyDataMarketplace.js
export const marketplaceGuidelinesData = [
  {
    section: '1. General Principles',
    rules: [
      'Trust & Transparency: All interactions must be honest, fair, and respectful.',
      'Compliance: All users must comply with applicable laws, regulations, and SmallSmall’s policies.',
      'Safety & Security: All transactions must be completed within the SmallSmall platform to ensure protection.',
      'Accountability: Buyers and vendors are responsible for their actions, listings, communications, and transactions on the platform.',
    ],
  },
  {
    section: '2. Guidelines for Buyers',
    steps: [
      {
        step: '2.1 Account & Profile',
        details: [
          'Register with accurate personal details.',
          'Keep your login details secure and confidential.',
          'Do not create multiple accounts to manipulate transactions.',
        ],
      },
      {
        step: '2.2 Purchasing Rules',
        details: [
          'Review product descriptions carefully before making a purchase.',
          'Ensure your delivery details are correct.',
          'Payments must be made only through the SmallSmall platform.',
          'Respect payment deadlines (for installment/credit-based purchases).',
        ],
      },
      {
        step: '2.3 Prohibited Buyer Conduct',
        details: [
          'Engaging in fraudulent chargebacks or false claims.',
          'Abusing return/refund policies.',
          'Harassing vendors or SmallSmall staff.',
          'Attempting to bypass the platform by transacting directly with vendors.',
        ],
      },
      {
        step: '2.4 Buyer Responsibilities',
        details: [
          'Inspect products upon delivery and raise complaints within the allowed timeframe.',
          'Provide clear and sufficient evidence when filing a dispute.',
          'Treat vendors and delivery agents with courtesy.',
        ],
      },
    ],
  },
  {
    section: '3. Guidelines for Vendors',
    steps: [
      {
        step: '3.1 Vendor Registration & Compliance',
        details: [
          'Vendors must provide accurate business information during onboarding.',
          'All required documentation (e.g., CAC registration, ID verification, product licenses) must be submitted.',
          'Vendors must comply with SmallSmall’s Vendor Agreement, tax laws, and relevant regulations.',
        ],
      },
      {
        step: '3.2 Product Listings',
        details: [
          'All listings must be accurate, truthful, and not misleading.',
          'Product descriptions must include specifications, conditions, pricing, and images.',
          'Vendors must ensure stock availability before listing.',
          'Prohibited items include counterfeit goods, illegal items, unsafe products, and anything restricted by Nigerian law or SmallSmall policy.',
        ],
      },
      {
        step: '3.3 Order Fulfillment',
        details: [
          'Vendors must process and ship orders promptly within stated timelines.',
          'Packaging should be secure and professional.',
          'Vendors must provide valid proof of delivery (where applicable).',
        ],
      },
      {
        step: '3.4 Customer Service',
        details: [
          'Vendors must respond promptly to buyer inquiries.',
          'Returns and refunds must be handled according to SmallSmall’s policies.',
          'Professional and respectful communication is mandatory at all times.',
        ],
      },
      {
        step: '3.5 Prohibited Vendor Conduct',
        details: [
          'Listing counterfeit, pirated, or restricted items.',
          'Providing false or misleading information about products.',
          'Cancelling orders frequently or failing to fulfill commitments.',
          'Attempting to divert buyers off-platform.',
          'Manipulating reviews or ratings.',
        ],
      },
    ],
  },
  {
    section: '4. Prohibited Items and Services',
    rules: [
      'Illegal or stolen goods.',
      'Counterfeit or imitation products.',
      'Weapons, ammunition, or explosives.',
      'Drugs, narcotics, or controlled substances.',
      'Adult or obscene materials.',
      'Hazardous or unsafe goods.',
      'Items restricted by law or SmallSmall’s internal compliance policy.',
    ],
  },
  {
    section: '5. Reviews and Ratings',
    rules: [
      'Buyers may leave reviews based on genuine experiences.',
      'Vendors may not manipulate, buy, or falsify reviews.',
      'Abusive, defamatory, or offensive reviews will be removed.',
    ],
  },
  {
    section: '6. Payments and Fees',
    rules: [
      'All payments must go through SmallSmall’s secure payment system.',
      'Vendors agree to applicable commissions or service fees set by SmallSmall.',
      'Buyers must honor agreed installment or direct debit obligations (if applicable).',
      'SmallSmall reserves the right to suspend accounts for payment defaults.',
    ],
  },
  {
    section: '7. Dispute Resolution',
    rules: [
      'Disputes must be raised via the SmallSmall platform.',
      'Both buyers and vendors are required to cooperate and provide evidence.',
      'SmallSmall will mediate disputes fairly and issue a binding resolution in line with platform policies.',
    ],
  },
  {
    section: '8. Account Suspension and Termination',
    rules: [
      'SmallSmall may suspend or terminate accounts for fraudulent or illegal activity.',
      'Repeated violations of marketplace guidelines.',
      'Non-compliance with applicable laws or SmallSmall policies.',
      'Attempts to damage the integrity of the platform.',
    ],
  },
  {
    section: '9. Data Protection & Privacy',
    rules: [
      'Buyers and vendors must respect data privacy laws.',
      'Personal data obtained during transactions may only be used for order fulfillment.',
      'Misuse of buyer/vendor data for spam, harassment, or off-platform solicitation is strictly prohibited.',
    ],
  },
  {
    section: '10. Enforcement of Guidelines',
    rules: [
      'Violations may result in warnings, listing removal, restricted access, suspension, or permanent account termination.',
      'SmallSmall reserves the right to take legal action in cases of fraud or criminal activity.',
    ],
  },
  {
    section: '11. Policy Updates',
    provisions: [
      'These Marketplace Guidelines may be updated from time to time in line with business needs, regulatory changes, or platform improvements. Users will be notified of major updates via email or in-app notifications.',
    ],
  },
  {
    section: '12. Contact Us',
    // Using 'contact' so your renderer shows a mailto link + note
    contact: {
      email: 'support@smallsmall.com',
      note: 'SmallSmall Technology Limited • Phone: (add phone number)',
    },
  },
];
